export default {
    VACINACAO: 1,
    DEMANDA_ESPONTANEA: 2,
    DEMANDA_AGENDADA: 3,
}